import {createSlice, PayloadAction} from '@reduxjs/toolkit'

export interface AccountState {
  currentAccountId: string | null
}

const initialAccountState: AccountState = {
  currentAccountId: null,
}

const accountSlice = createSlice({
  name: 'account',
  initialState: initialAccountState,
  reducers: {
    setCurrentAccount: (state, action: PayloadAction<string>) => {
      state.currentAccountId = action.payload
    },
    clearCurrentAccount: (state) => {
      state.currentAccountId = null
    },
  },
})

export const {setCurrentAccount, clearCurrentAccount} = accountSlice.actions
export default accountSlice.reducer
